<template>
  <div class="content" style="height: 100%;" @click="showHospitalPickerByKeyword = false">
    <td>
      <img class :src="(examType === 'pre' || examType === '') && preCoverUrl ? preCoverUrl : (examType === 'beh' && behCoverUrl) ?  behCoverUrl : defaultCoverUrl" style="width:100%;" />
      <!-- <img
        class
        src="../../assets/images/logo.png"
        style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"
      /> -->
    </td>
    <!-- <img class="banner" src="../../assets/images/banner.png" style="margin-top: -20px;" /> -->
    <div>
      <div class="news-detail">
        <div class="title" v-html="meetingName.replace(/\n|\r\n/g, '<br>')"></div>
<!--        <div class="examType" v-if="ruleForm.meetingType == 1 && ruleForm.examId && ruleForm.examId !=='null'"> 会前调研 </div>-->
<!--        <div class="content"  v-if="ruleForm.meetingType == 1 && ruleForm.examId && ruleForm.examId !=='null'" v-html="examType === 'beh' ? behRemark : preRemark"></div>-->
      </div>
    </div>
    <div class="card">
      <van-form @submit="submitForm">
        <div class="form_list">
          <div class="container" style="position:relative">
            <!-- <van-icon class="icon" :name="image_name" /> -->
            <van-field
                    v-model="ruleForm.name"
                    label="姓名"
                    placeholder="请输入姓名"
                    input-align="right"
                    :rules="[{ required: true }]"
            >
              <div slot="left-icon"><van-icon :name="image_name" /></div>
            </van-field>
          </div>

           <div v-if="!isEmployee" class="container" style="position:relative">

            <van-field
                readonly
                clickable
                :value="ruleForm.address"
                label="省市"
                placeholder="请选择省市"
                input-align="right"
                right-icon="arrow"
                :rules="[{ required: true }]"
                @click="showProvincePicker = true"
            >
              <div slot="left-icon"><van-icon :name="image_address" /></div>
            </van-field>
          </div>
          <div class="container" style="position:relative">
            <van-popup v-model="showProvincePicker" position="bottom">
              <van-area
                  title="医院"
                  :area-list="areaList"
                  :columns-num="2"
                  @confirm="getProvince"
                  @cancel="showProvincePicker = false"
              />
            </van-popup>
          </div>
          <div class="container" style="position:relative">

            <van-field
                v-model="ruleForm.remark"
                label="医院"
                placeholder="请输入医院"
                input-align="right"
                @input="queryHospitalAccordingTokeyword"
                @click="queryHospitalAccordingTokeyword(ruleForm.remark)"
                :rules="[{ required: true }]"
            >
              <div slot="left-icon"><van-icon :name="image_hospital" /></div>
            </van-field>
          </div>

          <div
              v-if="showHospitalPickerByKeyword"
              class="hospitalListByKeyword"
              style="position: absolute;z-index: 200;max-height: 200px;overflow-y: scroll;"
          >
            <van-cell
                style="background-color: #eee;"
                icon="hotel-o"
                v-for="(item, index) in hospitalListByKeyword"
                :key="index"
                :value="item"
                @click="getHospitalByKeyword(item)"
            >
              <template #right-icon>
                <van-icon name="search" class="search-icon" style="margin-top: 5px;" />
              </template>
            </van-cell>
          </div>

          <div v-if="!isEmployee" class="container" style="position:relative">
            <van-field
                    readonly
                    clickable
                    :value="ruleForm.department"
                    label="科室"
                    placeholder="请选择科室"
                    input-align="right"
                    right-icon="arrow"
                    :rules="[{ required: true }]"
                    @click="showDepartmentPicker = true"
            >
              <div slot="left-icon"><van-icon :name="image_department" /></div>
            </van-field>
          </div>

          <van-popup v-model="showDepartmentPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="departmentList"
                    value-key="value"
                    @confirm="getDepartment"
                    @cancel="showDepartmentPicker = false"
            />
          </van-popup>

          <div v-if="!isEmployee"  class="container" style="position:relative">
            <!-- <van-field
                    readonly
                    clickable
                    :value="ruleForm.category"
                    label="类别"
                    placeholder="请选择类别"
                    input-align="right"
                    right-icon="arrow"
                    :rules="[{ required: false }]"
                    @click="showCategoryPicker = true"
            >
              <div slot="left-icon"><van-icon :name="image_hospital" /></div>
            </van-field> -->
            <van-field label="类别" name="category" class="category-filed" :rules="[{ required: false }]">
              <div slot="left-icon"><van-icon :name="image_hospital" /></div>
              <template #input>
                <van-radio-group v-model="ruleForm.category" direction="horizontal" @change="onChangeCategory">
                  <van-radio v-for="(item,index) in categoryList" :name="item.value" :key="index">{{item.value}}</van-radio>
                </van-radio-group>                
              </template>
            </van-field>
          </div>

          <van-popup v-model="showCategoryPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="categoryList"
                    value-key="value"
                    @confirm="getCategory"
                    @cancel="showCategoryPicker = false"
            />
          </van-popup>

          <div v-if="ruleForm.category&&!isEmployee" class="container" style="position:relative">

            <van-field
                    readonly
                    clickable
                    :value="ruleForm.title"
                    label="职称"
                    placeholder="请选择职称"
                    input-align="right"
                    right-icon="arrow"
                    :rules="[{ required: false }]"
                    @click="showTitlePicker = true"
            >
              <div slot="left-icon"><van-icon :name="image_hospital" /></div>
            </van-field>
          </div>

          <van-popup v-model="showTitlePicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="titleList"
                    value-key="value"
                    @confirm="getTitle"
                    @cancel="showTitlePicker = false"
            />
          </van-popup>
        </div>
        <div class="container" style="position:relative">
          <van-field
              v-model="ruleForm.phone"
              label="手机号"
              type="number"
              :border="false"
              placeholder="请输入手机号"
              input-align="right"
              :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_phone" /></div>
          </van-field>
          <!-- <van-button v-show="show" type="info" @click="sendVcode" size="mini" class="phone-btn">发送验证码</van-button>
          <van-button v-show="!show" disabled  type="info" @click="sendVcode" size="mini" class="phone-btn">{{count}} s</van-button> -->
          <!-- <van-tag v-show="show" type="primary" @click="sendVcode" size="medium" class="phone-btn">发送验证码</van-tag>
          <van-tag v-show="!show" disabled type="primary" size="medium" class="phone-btn">{{count}} s</van-tag> -->
        </div>

        <div class="container" style="position:relative">
          <van-field
              v-model="ruleForm.vcode"
              label="验证码"
              type="number"
              placeholder="请输入验证码"
              input-align="right"
              :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_vcode" /></div>
            <template #button>
              <van-tag v-show="show" type="primary" @click="sendVcode" size="medium" class="phone-btn">发送验证码</van-tag>
              <van-tag v-show="!show" disabled type="primary" size="medium" class="phone-btn">{{count}} s</van-tag>
            </template>
          </van-field>
        </div>
        <div v-if="!isEmployee && showExam" class="container" style="position:relative">
          <van-cell-group v-for="(item, index) in questions" :key="index" class="cell-group">
            <div class="question"><span>{{index + 1}}.</span><span v-html="item.question.replace(/\n|\r\n/g, '<br>')"></span>
            <span v-if="item.type === 'RADIO'">(单选)</span>
            <span v-if="item.type === 'CHECKBOX'">(多选)</span>
            </div>
            <van-radio-group v-if="item.type === 'RADIO'" v-model="item.answer">
              <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
                <van-radio :name="option.seq">{{ option.value }}</van-radio>
                <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" value="" maxlength=100 style="background-color: #f7f7f7"/>
              </div>
            </van-radio-group>
            <van-checkbox-group v-if="item.type === 'CHECKBOX'" v-model="item.answer">
              <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
                <van-checkbox shape="square" :name="option.seq">{{ option.value }}</van-checkbox>
                <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" value="" maxlength=100 style="background-color: #f7f7f7"/>
              </div>
            </van-checkbox-group>
            <van-field v-if="item.type === 'TEXT'" rows="3" autosize type="textarea" v-model="item.answer" value="" input-align="left"/>
          </van-cell-group>
        </div>



        <van-button class="button" color="#8259E1" block native-type="submit">签到</van-button>
      </van-form>
    </div>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import API from "@/api/common";
import moment from "moment";
import Util from "@/utils/utils";
import image_name from "@/assets/images/name.png";
import image_phone from "@/assets/images/phone.png";
import image_vcode from "@/assets/images/vcode.png";
import image_address from "@/assets/images/addicon.png";
import image_hospital from "@/assets/images/hospital.png";
import image_department from "@/assets/images/department.png";
export default {
  data() {
    return {
      showTitlePicker: false,
      showCategoryPicker: false,
      show:true,
      showExam: false,
      isEmployee: false,
      count: '',
      timer: null,
      showProvincePicker: false,
      showHospitalPicker: false,
      showDepartmentPicker: false,
      hospitalInputIsShow: false,
      showHospitalPickerByKeyword: false,
      hospitalRequired: false,
      image_name: image_name,
      image_vcode: image_vcode,
      image_address: image_address,
      image_hospital: image_hospital,
      image_department: image_department,
      image_phone:image_phone,
      ruleForm: {
        name: "", // 姓名
        phone: "",
        vcode: "",
        province: "", // 省
        city: "", // 市
        hospital: "", // 医院
        address: "",
        remark: "", //其他医院
        openid: this.$route.query.openid,
        meetingId: this.$route.query.meetingId,
        meetingType: this.$route.query.meetingType,
        examId: this.$route.query.examId,
        unionid: this.$route.query.unionid,
        category: "", //类别
        title: "", //职称
        tbGroup: this.$route.query.tbGroup,
      }, // 表单内容
      departmentList: [],
      titleList: [],
      isTyping: this.$route.query.isTyping,
      categoryList: [],
      hospitalList: [],
      hospitalListByKeyword: [],
      cityListAll: [],
      areaJson: "",
      areaList: areaList,
      questions: [],
      preCoverUrl: '',
      behCoverUrl: '',
      defaultCoverUrl: require('../../assets/images/top.jpg'),
      meetingName: '',
      examType: this.$route.query.examType,
      preRemark: '',
      behRemark: '',
    };
  },
  created() {
    console.log(this.ruleForm)
    this.getDepartmentList();
    this.getCategoryList();
    this.getMeeting(this.ruleForm.meetingId)
    // if (this.ruleForm.meetingType == 1 && this.ruleForm.examId && this.ruleForm.examId !== 'null') {
    //   this.showExam = true
    //   this.findExam(this.ruleForm.examId)
    // }
  },
  methods: {
    getCategoryList() {
      API.findDictByCategory('customer_category').then((data) => {
        if (data && data.data.length > 0) {
          this.categoryList = [];
          data.data.forEach((element) => {
            this.categoryList.push({
              value: element.value,
            });
          });
        }
      });
    },
    queryCategoryAccordingTokeyword(keyword) {
      // 这里是根据keyword关键字查询接口
      if (!keyword) {
        this.showHospitalPickerByKeyword = false
        this.isEmployee = false
        return
      }
      else if (keyword === '纽迪希亚') {
        this.isEmployee = true
        return
      } else {
        this.isEmployee = false
        API.searchHospitalBykeyword(keyword, this.ruleForm.city).then((data) => {
          this.hospitalListByKeyword = [];
          if (data && data.data.length > 0) {
            // 查到相关的医院，保存接口返回的数组，并打开弹窗

            data.data.forEach((element) => {
              this.hospitalListByKeyword.push(element.hosName);
            });
            console.info(this.hospitalListByKeyword[0]);
            this.showHospitalPicker = false;
            this.showHospitalPickerByKeyword = true;
          } else {
            // 没有查到相关的医院
          }
        });
      }

    },
    getDepartmentList() {
      API.getDepartmentList().then((data) => {
        if (data && data.data.length > 0) {
          this.departmentList = [];
          data.data.forEach((element) => {
            this.departmentList.push({
              value: element.department,
            });
          });
        }
      });
    },
    // getCategoryList() {
    //   API.findDictByCategory('customer_category').then((data) => {
    //     if (data && data.data.length > 0) {
    //       this.categoryList = [];
    //       data.data.forEach((element) => {
    //         this.categoryList.push({
    //           value: element.value,
    //         });
    //       });
    //     }
    //   });
    // },
    getTitleList(category) {
      API.findDictByCategory(category).then((data) => {
        if (data && data.data.length > 0) {
          this.titleList = [];
          data.data.forEach((element) => {
            this.titleList.push({
              value: element.value,
            });
          });
        }
      });
    },
    getCategory(value) {
      console.info(value);
      if (this.ruleForm.category !== value.value) {
        this.ruleForm.category = value.value;
        this.ruleForm.title = '';
      }
      this.showCategoryPicker = false;
      this.getTitleList(value.value);
    },
    onChangeCategory(value){
       this.getTitleList(value);
    },
    getTitle(value) {
      console.info(value);
      this.ruleForm.title = value.value;
      this.showTitlePicker = false;
    },
    getHospitalList() {
      if (this.ruleForm.city === "") {
        this.$message.error("请先选择省市！");
        return;
      }
      API.searchHospitalByCity(this.ruleForm.city).then((data) => {
        if (data && data.data.length > 0) {
          this.hospitalList = [];

          data.data.forEach((element) => {
            this.hospitalList.push({
              value: element.hosName,
            });
          });

          this.ruleForm.hospital = this.hospitalList[0].value;

          this.hospitalList.push({
            value: "其他",
          });
          this.hospitalRequired = true;
          this.showHospitalPicker = true;
        } else {
          this.hospitalRequired = false;
          this.hospitalInputIsShow = true;
        }
      });
    },
    showHospitalToInput() {
      if (this.ruleForm.city === "") {
        this.$message.error("请先选择省市！");
        return;
      }
    },
    queryHospitalAccordingTokeyword(keyword) {
      // 这里是根据keyword关键字查询接口
      if (!keyword) {
        this.showHospitalPickerByKeyword = false
        this.isEmployee = false
        return
      }
      else if (keyword === '纽迪希亚') {
        this.isEmployee = true
        return
      } else {
        this.isEmployee = false
        API.searchHospitalBykeyword(keyword, this.ruleForm.city).then((data) => {
          this.hospitalListByKeyword = [];
          if (data && data.data.length > 0) {
            // 查到相关的医院，保存接口返回的数组，并打开弹窗

            data.data.forEach((element) => {
              this.hospitalListByKeyword.push(element.hosName);
            });
            console.info(this.hospitalListByKeyword[0]);
            this.showHospitalPicker = false;
            if (this.hospitalListByKeyword.length == 1 && keyword == this.hospitalListByKeyword[0]) {
              this.showHospitalPickerByKeyword = false;
            } else {
              this.showHospitalPickerByKeyword = true;
            }
          } else {
            // 没有查到相关的医院
          }
        });
      }

    },
    // getDepartmentList() {
    //   API.getDepartmentList().then((data) => {
    //     if (data && data.data.length > 0) {
    //       this.departmentList = [];
    //       data.data.forEach((element) => {
    //         this.departmentList.push({
    //           value: element.department,
    //         });
    //       });
    //     }
    //   });
    // },
    createCustomerSign() {
      console.info(this.ruleForm);
      console.log(this.ruleForm)
      API.createMeetingSign(this.ruleForm).then((data) => {
        if (data.success) {
          if (this.showExam) {
            this.submitExam()
          }
          if (this.ruleForm.meetingType == 1 ) {
            //城市会跳转页面
            //先获取到examId
            API.getCityExamIdByDepartment(this.ruleForm.openid,this.ruleForm.meetingId).then((data) => {
              let query = { openid: this.ruleForm.openid, meetingId: this.ruleForm.meetingId, department: this.ruleForm.department, examType: this.examType,toPage:'cityexam', answer:3,examId: data.data,isTyping: this.isTyping}

              if(data.data=='null'&&this.isTyping=='0'){
                //没有问卷且没有设置分型
                query = { openid: this.ruleForm.openid, meetingId: this.ruleForm.meetingId, department: this.ruleForm.department, examType: this.examType,toPage:'cityexam', isTyping: this.isTyping}
              }
              this.$router.push({
                name: "wechatSuccess",
                query: query
              });
            })

          }else{
            let query = { openid: this.ruleForm.openid, meetingId: this.ruleForm.meetingId, examId: this.ruleForm.examId, examType: this.examType }
            this.$router.push({
              name: "wechatSuccess",
              query: query
            });
          }

        } else {
          this.$message.error(data.message);
        }
      });
    },
    createEmployeeSign() {
      console.info(this.ruleForm);
      this.isEmployee = true
      this.ruleForm.address = null;
      this.ruleForm.province = null;
      this.ruleForm.city = null;
      this.ruleForm.hospital = null;
      this.ruleForm.category = null;
      this.ruleForm.department = null;
      this.ruleForm.title = null;
      API.createMeetingSign(this.ruleForm).then((data) => {
        if (data.success) {
          if (this.showExam) {
            this.submitExam()
          }
          if (this.ruleForm.meetingType == 1 ) {
            //城市会跳转页面
            //先获取到examId
            API.getCityExamIdByDepartment(this.ruleForm.openid,this.ruleForm.meetingId).then((data) => {
              let query = { openid: this.ruleForm.openid, meetingId: this.ruleForm.meetingId, department: "", examType: this.examType,toPage:'cityexam', answer:3,examId: data.data}
              this.$router.push({
                name: "wechatSuccess",
                query: query
              });
            })

          }else{
            let query = { openid: this.ruleForm.openid, meetingId: this.ruleForm.meetingId, examId: this.ruleForm.examId, examType: this.examType }
            this.$router.push({
              name: "wechatSuccess",
              query: query
            });
          }

        } else {
          this.$message.error(data.message);
        }
        // if (data.success) {
        //   this.$router.push({
        //     name: "wechatSuccess",
        //     query: { openid: this.ruleForm.openid, meetingId: this.ruleForm.meetingId, examId: this.ruleForm.examId, examType: this.examType },
        //   });
        // } else {
        //   this.$message.error(data.message);
        // }
      });
    },
    // createCustomerInfo() {
    //   console.info(this.ruleForm);
    //   const openid = this.ruleForm.openid
    //   const meetingId = this.ruleForm.meetingId
    //   const examId = this.ruleForm.examId
    //   const param = {tbName: this.ruleForm.name, province: this.ruleForm.province, city: this.ruleForm.city, vcode: this.ruleForm.vcode,
    //     tbMobile: this.ruleForm.phone, hosName: this.ruleForm.remark, department: this.ruleForm.department, openid: this.ruleForm.openid }
    //   let toPage = 'wechatSuccess'
    //   // 全国会并且examId有值，跳转注册成功页
    //   if (this.ruleForm.meetingType == 2 && this.ruleForm.examId) {
    //     toPage = 'registerSuccess'
    //   }
    //   API.createCustomerInfo(param).then((data) => {
    //     if (data.success) {
    //       this.$router.push({
    //         name: toPage,
    //         query: { openid: openid, meetingId: meetingId, examId: examId }
    //       });
    //     } else {
    //       this.$message.error(data.message);
    //     }
    //
    //   });
    // },
    // 新增医生主数据
    submitForm(data) {
      if (this.isEmployee) {
        this.createEmployeeSign()
      } else {
        if (this.showExam) {
          if (this.valid()) {
            this.createCustomerSign();
          } else {
            this.$message.error('还有问题未填写')
          }
        } else {
          this.createCustomerSign();
        }
      }

    },
    getProvince(value) {
      this.ruleForm.address = value[0].name + "-" + value[1].name;
      this.ruleForm.province = value[0].name;
      this.ruleForm.city = value[1].name;
      this.ruleForm.hospital = "";
      this.ruleForm.remark = "";
      this.hospitalList = [];
      this.hospitalListByKeyword = [];
      this.showProvincePicker = false;
      this.hospitalInputIsShow = true;
      this.hospitalRequired = true;
    },
    getHospital(value) {
      this.ruleForm.hospital = value.value;
      this.showHospitalPicker = false;
    },
    getHospitalByKeyword(value) {
      console.info(value);
      this.ruleForm.remark = value;
      this.showHospitalPickerByKeyword = false;
    },
    getDepartment(value) {
      this.ruleForm.department = value.value;
      this.showDepartmentPicker = false;
    },
    sendVcode(phone) {
      if(!this.ruleForm.phone){
        this.$message.error("请输入手机号!");
        return
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
      API.sendVcode(this.ruleForm.phone).then((data) => {
        this.$message.success("发送成功!");
      });
    },
    getMeeting(meetingId) {
      API.getMeeting(meetingId).then(result => {
        this.preCoverUrl = result.data.preCoverUrl
        this.behCoverUrl = result.data.behCoverUrl
        this.meetingName = result.data.tbTitle
        this.preRemark = result.data.preRemark
        this.behRemark = result.data.behRemark
      })
    },
    findExam(examId) {
      API.findExam(examId).then(result => {
        this.questions = result.data.questionList
        this.questions.forEach( item => {
          if (item.type == 'RADIO') {
            item.answer = ''
          } else if (item.type == 'CHECKBOX') {
            item.answer = []
          }
        })
      })
    },
    valid() {
      let valid = true
      this.questions.forEach( item => {
        if (item.type == 'RADIO' && !item.answer) {
          valid = false
        } else if (item.type == 'CHECKBOX' && !item.answer.length > 0) {
          valid = false
        } else if (item.type == 'TEXT' && !item.answer) {
          valid = false
        }
      })
      return valid
    },
    submitExam() {
      let questionList = []
      this.questions.forEach( item => {
        let question = { stockId: item.stockId, answer: item.answer.toString(), otherAnswer: item.otherAnswer }
        questionList.push(question)
      })
      API.saveResult({ meetingId: this.ruleForm.meetingId, examId: this.ruleForm.examId, examType: this.examType, openid: this.ruleForm.openid, quesList: questionList }).then(data => {

      })
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  .banner {
    width: 100%;
    height: auto;
  }
  .container{
    margin:8px 0;
  }
  .icon {
    position: absolute;
    left: 15px;
    z-index: 10;
    top:-3px;
  }
  .phone {
    width: 74%;
    float: left;
  }
  .button {
    width: 90%;
    margin: 25px auto;
    border-radius: 6px;
  }
  .phone-btn {
    // min-width: 21%;
    vertical-align: middle;
  }
  .card {
    position: relative;
    width: 90%;
    height: 100%;
    margin: 0 auto;
    // background-color: #fff;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
      color: #646566;
    }

    .hospitalListByKeyword {
      width: 100%;
      height: auto;
      margin: 0 auto;
      background-color: #fff;
    }
    .form_list {
      background-color: #fff;
    }
  }
  /deep/.van-cell-group{
    .question{
      font-size: 14px;
      // border-bottom: 1px solid #eee;
      padding: 5px 0;
    }
    .van-radio{
      margin:8px 0;
      font-size: 14px;
    }
    .van-checkbox__label{
      margin:8px;
      font-size: 14px;
    }
    margin:10px 0px;
    padding: 10px;
    border-radius: 5px;
    color: #646566;
  }
  .news-detail {
    height: 100%;
    margin-top: 20px;
    padding-bottom: 10px;
    overflow: auto;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
      color: #646566;
    }
    .examType {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      color: #646566;
    }
    .content {
      margin: 0 10px;
      font-size: 16px;
    }
  }
}
</style>
<style lang="less">
.content {
  .van-field__label {
    margin-left: 6px;
  }

  .van-icon__image {
    width: 18px;
    height: 18px;
  }
  .van-radio__label {
    color: #646566;
  }
  .category-filed {
    .van-field__label {
      width: 3em;
    }
    .van-field__value {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
